import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Fragment } from "react";
import { XIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { cva } from "class-variance-authority";

import IconButton from "@/components/buttons/IconButton";
import AvatarCard from "./AvatarCard";


type SlideOverProps = {
    isOpen: boolean
    title?: string
    subtitle?: string
    icon?: React.ReactNode
    intent?: "primary" | "secondary" | "danger" | "default"
    size?: "xs" | "sm" | "md" | "lg" | "xl"
    children: React.ReactNode
    onClose: (value: boolean) => void,
    className?: string
}

const SlideOver = (props: SlideOverProps) => {

    const styleClassName = () => {
        const defaultClass = `min-h-full p-4 rounded-2xl bg-white border border-zinc-200 space-y-8`

        const config = {
            variants: {
                intent: {
                    primary: "bg-primary text-white border-primary hover:bg-primary-600",

                    secondary: "bg-white text-primary border-primary hover:bg-primary-50",

                    danger: "bg-rose-800 text-white border-rose-800 hover:bg-rose-700",

                    default: "bg-white",
                },
                size: {
                    xs: "w-full md:max-w-xs xl:max-w-sm",
                    sm: "w-full md:max-w-md xl:max-w-lg",
                    md: "w-full md:max-w-xl xl:max-w-2xl",
                    lg: "w-full md:max-w-2xl xl:max-w-3xl",
                    xl: "w-full max-w-3xl xl:max-w-5xl",
                }
            }
        }

        return cva(defaultClass, config)({
            intent: props.intent ?? "default",
            size: props.size ?? "sm"
        })
    }

    return (
        <Transition show={props.isOpen} as={Fragment}>
            <Dialog 
                as="div"
                className="fixed inset-0 z-50" 
                onClose={() => props.onClose(false)}
            >
                <TransitionChild
                    as={Fragment}
                    enter="transition-opacity ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="absolute -z-10 inset-0 bg-black/40" />
                </TransitionChild>

                <div className={twMerge("flex flex-col items-end p-4")}>
                    <TransitionChild
                        as={Fragment}
                        enter="transition-transform duration-500"
                        enterFrom="translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition-transform duration-500"
                        leaveFrom="translate-x-0"
                        leaveTo="translate-x-full"
                    >
                        <DialogPanel 
                            className={twMerge(styleClassName(), props.className)}
                        >
                            <div className="flex justify-between items-center">
                                {
                                    (props.title || props.icon) && (
                                        <AvatarCard 
                                            title={props.title ?? ""}
                                            subTitle={props.subtitle}
                                            leading={props.icon && props.icon}
                                            titleClassName="text-base lg:text-lg font-medium"
                                        />
                                    )
                                }

                                <IconButton 
                                    intent="secondary"
                                    className="p-1"
                                    onClick={() => props.onClose(false)}
                                >
                                    <XIcon className="size-5" />
                                </IconButton>
                            </div>

                            <div className="bg-ember-400 h-[84vh] overflow-y-auto">
                                {props.children}
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
               

            {/* <div className={`absolute inset-0 `}>
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                    <DialogPanel className={twMerge(styleClassName(), props.className)}>
                        <div className="m-4 xl:m-6">
                            <div className="flex justify-between">
                                {
                                    props.title && (
                                        <AvatarCard 
                                            title={props.title}
                                            subTitle={props.subtitle}
                                            leading={props.icon && props.icon}
                                        />
                                    )
                                }
                                <section className="flex-1">
                                    {
                                        props.icon && (
                                            <div className="rounded-lg border border-secondary-50/50 p-2.5">
                                                {props.icon}
                                            </div>
                                        )
                                    }
                                    {
                                        props.title && (
                                            <div className="mb-6 px-2">
                                                <h2 className="text-zinc-800 font-semibold">
                                                    { props.title }
                                                </h2>
                                                <p className="text-xs text-zinc-600">
                                                    {props.subtitle}
                                                </p>
                                            </div>
                                        )
                                    }

                                    
                                </section>

                                <section>
                                    <IconButton 
                                        intent="secondary"
                                        onClick={() => props.onClose(false)}
                                    >
                                        <XIcon className="size-5" />
                                    </IconButton>
                                </section>
                            </div>

                            <div className="rounded-b-md max-h-[80vh] overflow-y-auto">
                                {props.children}
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div> */}

            </Dialog>
        </Transition>
    )
}

export default SlideOver